/**
 * WorkDaysFilterInput Component
 * 최소 근무일수 입력 필터
 */
import React from 'react';
import { RiderWorkStatusFilters } from '../../types/riderWorkStatus.types';

interface WorkDaysFilterInputProps {
    minWorkDays: string | undefined;
    onFilterChange: (key: keyof RiderWorkStatusFilters, value: string) => void;
    onSearch: () => void;
}

const WorkDaysFilterInput: React.FC<WorkDaysFilterInputProps> = ({ minWorkDays, onFilterChange, onSearch }) => {
    const handleKeyDown = (e: React.KeyboardEvent) => {
        if (e.key === 'Enter') {
            onSearch();
        }
    };

    return (
        <div className="form-group">
            <div className="form-field">
                <label className="form-label">
                    <i className="fas fa-calendar-check" />
                    최소 근무일수
                </label>
                <input
                    type="number"
                    className="text-input work-days-input"
                    value={minWorkDays || ''}
                    onChange={(e) => onFilterChange('minWorkDays', e.target.value)}
                    onKeyDown={handleKeyDown}
                    placeholder="0"
                    min="0"
                />
            </div>
        </div>
    );
};

export default WorkDaysFilterInput;
